import {CreditCardIcon, OfficeBuildingIcon, DownloadIcon} from '@heroicons/react/solid'
import {ReactComponent as PayPalLogo} from "../../../../assets/images/logo-paypal.svg";
import {BUTTON_VARIANT_TYPES} from "../../../../utils/constants";
import Button from "../../../SharedComponents/Button";

function BillingRow(props) {
    const {transaction} = props;

    return (
        <tr>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-blue-gray-600 ">
                        {transaction.date}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-indigo-900">
                        {transaction.payee}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>

                    {transaction.method === "CREDIT CARD" &&
                        <span className={"text-xs font-medium text-secondary-600 flex items-center"}>
                            <CreditCardIcon className="h-3.5 w-3.5 mr-1"/>{transaction.method}
                        </span>
                    }
                    {transaction.method === "BANK TRANSFER" &&
                        <span className={"text-xs font-medium text-indigo-600 flex items-center"}>
                            <OfficeBuildingIcon className="h-3.5 w-3.5 mr-1"/>{transaction.method}
                        </span>
                    }
                    {transaction.method === "PAY PAL" &&
                        <span className={"text-xs font-medium text-primary-600 flex items-center"}>
                            <PayPalLogo className="h-3.5 w-3.5 mr-1 fill-current text-primary-600"/>{transaction.method}
                        </span>
                    }
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <span className={"text-xs font-medium " +
                        (transaction.type === "CREDIT" ?
                            "text-green-600"
                            :
                                "text-amber-600"
                        )}>
                                {transaction.type}
                    </span>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-blue-gray-600">
                        {transaction.amount}
                    </div>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap">
                <div className={"flex flex-row gap-3 items-center"}>
                        <span className={"text-xs font-medium p-1 px-2 rounded-full " +
                        (transaction.status === "SUCCESSFUL" ?
                            "text-green-600 bg-green-100"
                            :
                            transaction.status === "FAILED" ?
                                "text-red-600 bg-red-100"
                                :
                                transaction.status === "PENDING" ?
                                    "text-amber-600 bg-amber-100"
                                    :
                                    transaction.status === "AUTHORISED" ?
                                        "text-primary-600 bg-primary-100"
                                        :
                                        "text-blue-gray-600 bg-blue-gray-100")

                        }>
                                {transaction.status}
                        </span>
                </div>
            </td>
            <td className="px-4 py-3 whitespace-nowrap hidden lg:table-cell">
                <div className={"flex flex-row gap-3 items-center"}>
                    <div className="text-sm font-medium text-blue-gray-500">
                        {transaction.invoice === "PROCESSING" ?
                            "Processing"
                            :
                            transaction.invoice === "UNAVAILABLE" ?
                                "-"
                                :
                                <Button
                                    onClick={transaction.invoice}
                                    iconPositionLeft
                                    icon={<DownloadIcon className="block h-4 w-4 mr-2"/>}
                                    colour={BUTTON_VARIANT_TYPES.UNCOLOURED}
                                    text="Download"
                                    extraStyling="shadow-none text-secondary-600 p-0"
                                />
                        }
                    </div>
                </div>
            </td>
        </tr>
    )
}

export default BillingRow;
